import { MailboxData } from "../../Pages/Email-accounts/DomainEmailAccounts";

export const parseSize = (size: string): number => {
  const value = parseFloat(size);
  if (size.includes('Go') || size.includes('GB')) {
    return value * 1024;
  }
  return value;
};

export const getProgressVariant = (percentage: number): string => {
  if (percentage >= 90) return 'danger';
  if (percentage >= 75) return 'warning';
  return 'success';
};

export interface QuotaData {
  used: string;
  total: string;
  percentage: number;
  variant: string;
}

// Calcul du pourcentage de comptes messagerie utilisés
export const getQuotaPercentage = (used: number, max: number): number => {
  if (max === 0) return 0; // Quota illimité
  return Math.round((used / max) * 100);
};

export const getQuotaVariant = (percentage: number): string => {
  if (percentage >= 90) return 'danger';
  if (percentage >= 75) return 'warning';
  return 'success';
};

export const getTransportTypeLabel = (mailboxData: MailboxData | null): string => {
  const type = mailboxData?.type || mailboxData?.transportType || '';

  switch (type.toLowerCase()) {
    case 'virtual':
      return 'Mails CELESTE';
    case 'zimbra':
      return 'Groupware';
    default:
      return 'Relais de messagerie';
  }
};